<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      :close-on-click-modal="false"
      append-to-body
      title="选择工艺路线"
      top="8vh"
      width="800px">
    <table-select
        ref="tableSelect"
        :filter="filter"
        :columns="columns"
        module="basic"
        url="rtRoutes"
        sel-reset
        @reset="resetHandle"
        @select="selectRtRoute">
      <template slot="adSearch">
        <el-form ref="form" :inline="true" :model="filter">
          <el-form-item label="名称" prop="routingName">
            <el-input v-model.trim="filter.routingName" placeholder="请输入工艺路线名称" clearable/>
          </el-form-item>
        </el-form>
      </template>
    </table-select>
  </el-dialog>
</template>

<script>
  import TableSelect from "@/components/TableSelect.vue";

  export default {
    components: { TableSelect },
    data() {
      return {
        dialogVisible: false,
        filter: {
          routingName: "",
        },
        columns: [
          {
            title: "编号",
            key: "routeNo",
            width: 120,
            align: "center",
          },
          {
            title: "名称",
            key: "routingName",
          },
          {
            title: "操作",
            slot: "action",
            width: 80,
            align: "center",
            fixed: "right",
          },
        ],
      };
    },
    methods: {
      open(workCenterId) {
        this.dialogVisible = true;
        this.$nextTick(() => {
          this.$refs.form.resetFields();
          this.filter.workCenterId = workCenterId;
          this.$refs.tableSelect.loadData();
        });
      },

      selectRtRoute(row) {
        this.dialogVisible = false;
        this.$emit("select", row);
      },

      resetHandle() {
        this.$refs.form.resetFields();
        this.$refs.tableSelect.loadData();
      },
    },
  };
</script>
